
define('jsx!components/login-public-tenant/button-sign-in',[
	"react",
	"jsx!components/shared/loading-button"
], function (React, LoadingButton)
{
	return React.createClass({
		displayName: "SignInButton",
		getDefaultProps: function ()
		{
			return {
				"validating": false,
				"username": null,
				"password": null,
				"progress": 0,
				"max_progress": 999,
				"onClick": function () {}
			};
		},
		onClick: function (e) {
			if(this.props.validating) {
				return;
			} 
			this.props.onClick(e);
		},
		render: function ()
		{
			var classNames = ["btn", "btn-primary"];
			var progressStyle = {};

			if (Math.abs(this.props.progress - this.props.max_progress) > 0) {
				progressStyle["backgroundPosition"] ="100% 100%"
			}

			return (
				React.createElement("div", {className: "form-group"}, 
					React.createElement(LoadingButton, {
						className:  classNames, 
						id: "btn-sign-in", 
						onClick: this.onClick, 
						style: progressStyle, 
						loading:  this.props.validating, 
						disabled:  this.props.validating || this.props.username === null, 
						text: this.props.password === null ? "Next" : "Sign in"}
					)
				)
			);
		}
	})
});
